import { el, clear, debounce } from '../../utils/dom.js';
import { Items, Categories } from '../../api/resources.js';
import { dataTable } from '../../components/table.js';
import { statusBadge } from '../../components/badge.js';
import { fmtNumber, fmtMoney } from '../../utils/format.js';
import { confirm } from '../../components/modal.js';
import { ok, err } from '../../components/toast.js';

export default async function InventoryListPage(outlet) {
  clear(outlet);
  const state = { page: 1, q: '', kind: '', categoryId: '' };

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Inventario'),
    el('a', { href: '#/inventory/new', class: 'btn primary' }, '+ Nuevo item'),
  ));

  // Filtros
  const cats = await Categories.list({ limit: 200 }).catch(() => ({ data: [] }));
  const catSelect = el('select', { class: 'select', onchange: (e) => { state.categoryId = e.target.value; state.page = 1; refresh(); } },
    el('option', { value: '' }, 'Toda categoria'),
    ...((cats.data || []).map((c) => el('option', { value: c.id }, c.name))),
  );

  const kindSelect = el('select', { class: 'select', onchange: (e) => { state.kind = e.target.value; state.page = 1; refresh(); } },
    el('option', { value: '' }, 'Todo tipo'),
    el('option', { value: 'serialized' }, 'Serializado'),
    el('option', { value: 'bulk' }, 'Bulk'),
  );

  const search = el('input', {
    class: 'input grow',
    placeholder: 'Buscar por nombre, marca, modelo, codigo...',
    oninput: debounce((e) => { state.q = e.target.value; state.page = 1; refresh(); }, 300),
  });

  outlet.appendChild(el('div', { class: 'toolbar' }, search, kindSelect, catSelect));

  const tableHost = el('div');
  outlet.appendChild(tableHost);

  async function refresh() {
    tableHost.innerHTML = '<div class="empty">Cargando...</div>';
    try {
      const res = await Items.list({
        page: state.page, limit: 25,
        q: state.q || undefined,
        kind: state.kind || undefined,
        category_id: state.categoryId || undefined,
      });
      const rows = res.data || [];
      tableHost.replaceChildren(dataTable({
        columns: [
          { key: 'name', label: 'Item', render: (r) => el('div', {},
            el('div', { class: 'text-bold' }, r.name),
            el('div', { class: 'text-xs muted' }, [r.brand, r.model].filter(Boolean).join(' · ')),
          ) },
          { key: 'kind',  label: 'Tipo', render: (r) => r.kind === 'serialized' ? 'Serializado' : 'Bulk' },
          { key: 'category_name', label: 'Categoria', render: (r) => r.category_name || '—' },
          { key: 'internal_code', label: 'Codigo', render: (r) => el('span', { class: 'text-mono text-sm' }, r.internal_code || '—') },
          { key: 'stock', label: 'Stock', className: 'right', render: (r) => {
              if (r.kind === 'serialized') return el('span', { class: 'muted' }, '—');
              const used = (r.quantity_reserved||0)+(r.quantity_loaned||0)+(r.quantity_rented||0)+(r.quantity_maintenance||0)+(r.quantity_damaged||0)+(r.quantity_lost||0);
              const avail = (r.quantity_total||0) - used;
              const lowClass = avail <= (r.min_stock || 0) ? 'badge danger' : 'badge';
              return el('span', { class: lowClass }, `${avail}/${r.quantity_total}`);
          } },
          { key: 'price', label: 'Renta/dia', className: 'right', render: (r) => fmtMoney(r.default_rental_price_per_day) },
          { key: '_act', label: '', className: 'right', render: (r) => el('div', { class: 'row-actions' },
            el('a', { href: `#/inventory/${r.id}`, class: 'btn sm' }, 'Ver'),
            el('a', { href: `#/inventory/${r.id}/edit`, class: 'btn sm' }, 'Editar'),
            el('button', {
              class: 'btn sm danger',
              onclick: async () => {
                if (await confirm({ title: 'Eliminar item', message: `Eliminar "${r.name}"?`, danger: true, confirmText: 'Eliminar' })) {
                  try { await Items.remove(r.id); ok('Eliminado'); refresh(); }
                  catch (ex) { err(ex.message); }
                }
              },
            }, 'Eliminar'),
          ) },
        ],
        rows,
        pagination: res.pagination ? {
          page: res.pagination.page, pages: res.pagination.pages,
          onPage: (p) => { state.page = p; refresh(); },
        } : null,
      }));
    } catch (ex) {
      tableHost.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    }
  }
  refresh();
}
